import React from 'react';
import PropTypes from 'prop-types';
import { Range, createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';

// import './FormComponents.scss';

const RangeWithTooltip = createSliderWithTooltip(Range);

export default class RangeSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  onChange(newVal) {
    this.setState({ value: newVal });
  }

  render() {
    const { onChange, value, ...rest } = this.props;

    return (
      <RangeWithTooltip
        value={this.state.value}
        onChange={this.onChange}
        {...rest}
      />
    );
  }
}

RangeSelect.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  phonePrefix: '+1',
  placeholder: 'Enter phone number',
  name: 'phone',
  value: '',
  className: '',
};

RangeSelect.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  phonePrefix: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
};
